import { rankWith, schemaMatches } from '@jsonforms/core';

export default rankWith(
  3, //increase rank as needed
  schemaMatches((schema) => schema.hasOwnProperty('rows') && schema.hasOwnProperty('columns') && !(schema.hasOwnProperty('uniqueItems') && schema['uniqueItems']))
);
